import { Lightning } from "@lightningjs/sdk";
import { List } from "@lightningjs/ui";
import { TranslatableText } from "../../../../components/data-display/TranslatableText/TranslatableText";
import { Icon } from "../../../../components/data-display/Icon/Icon";
import { MediaModel } from "../../../../lib/models";
import { MENU_WIDTH } from "../../../../lib/utils";
import theme from "../../../../lib/theme";
import { Theme } from "../../../../components/configurations/Theme/ThemeManager";
import configs from "../../../../lib/configs";
import { MediaList } from "../../../../components/data-display/MediaList/MediaList";
import { MovieFullScreen } from "../../../../components/data-display/MovieDetails/MovieFullScreen";

interface SeriesDetailsFullScreenTemplateSpec extends Lightning.Component.TemplateSpec {
    Movie: typeof MovieFullScreen;
    DetailsLabel: {
        Label: typeof TranslatableText;
        Icon: typeof Icon;
    };
    Seasons: typeof List;
    List: typeof MediaList;
}

export class SeriesDetailsFullScreen
    extends Lightning.Component<SeriesDetailsFullScreenTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<SeriesDetailsFullScreenTemplateSpec>
{
    _selectedSeason = 0;
    _hasSeasons = false;
    _data!: MediaModel;

    private _themeCallback!: (customTheme: Theme | undefined) => void;
    static _offsetX = configs.layout.content.alignWithBanner ? theme.banner.padding.x : theme.layout.content.x;

    static override _template(): Lightning.Component.Template<SeriesDetailsFullScreenTemplateSpec> {
        return {
            w: theme.layout.w,
            x: MENU_WIDTH,
            collision: true,
            Movie: {
                collision: true,
                type: MovieFullScreen,
                w: theme.layout.w - this._offsetX * 2 - MENU_WIDTH,
                h: 552,
                x: this._offsetX,
                y: 58,
                coverSize: {
                    h: 580,
                    w: 435
                }
            }
            // Seasons: {
            //     type: List,
            //     collision: true,
            //     spacing: 16,
            //     x: this._offsetX,
            //     y: 680,
            //     w: theme.layout.w - this._offsetX * 2 - MENU_WIDTH,
            //     signals: { onIndexChanged: true }
            // },
            // List: {
            //     type: MediaList,
            //     collision: true,
            //     h: (h: number) => h,
            //     w: (w: number) => w,
            //     y: 680 + (configs.hasSeasons ? 90 : 62)
            // }
        };
    }

    // readonly Seasons = this.getByRef("Seasons")!;
    // readonly List = this.getByRef("List")!;
    readonly Movie = this.getByRef("Movie")!;

    set data(movie: MediaModel) {
        // window.selectedMovie = movie;
        //
        // this._selectedSeason = 0;

        this._data = movie;

        // this.application.emit("updateSelectedMovie", window.selectedMovie);
        //
        // this.application.emit("clearBackground");
        // this.application.emit("updateSelectedMovie", movie);

        this.Movie.patch({
            data: movie
        });

        // const episodes = this._data?.items || this._data?.seasons![this._selectedSeason]?.episodes || [];
        // this.List.resetItems(episodes);
        // const parentId = this._data?.seasons![this._selectedSeason]?.id;
        // if (!episodes.length && parentId) {
        //     this.List.patch({
        //         seriesId: this._data.id,
        //         parentId: parentId
        //     });
        //     console.log("no eps, try load", {
        //         seriesId: this._data.id,
        //         parentId: parentId
        //     });
        //     // this.List.clear();
        //     // this.List.onRequestItems();
        // }
        //
        // if (configs.hasSeasons && movie.seasons) {
        //     this._hasSeasons = true;
        //     this.Seasons.items = movie.seasons.map((item, index) => ({
        //         type: Button,
        //         isActive: this._selectedSeason === index,
        //         useBorder: true,
        //         label: `Season ${item.seasonNumber}`,
        //         h: 56,
        //         w: 140,
        //         actionId: "season"
        //     }));
        // } else {
        //     this._hasSeasons = false;
        // }
    }

    // $handleBtnClick() {
    //     if (this._selectedSeason === this.Seasons.index) return;
    //
    //     this._selectedSeason = this.Seasons.index;
    //
    //     this.Seasons.items.map((item: any, index: number) => {
    //         item.isActive = this._selectedSeason === index;
    //         return item;
    //     });
    //
    //     this.List.resetItems(this._data.seasons![this._selectedSeason]!.episodes || []);
    // }

    // onIndexChanged({ index }: any) {
    //     if (this._hasSeasons) {
    //         window.selectedMovie = {
    //             ...this._data,
    //             releaseYear: this._data.seasons![index]?.releaseYear
    //         };
    //         this.application.emit("updateSelectedMovie", window.selectedMovie!);
    //     }
    // }

    override _getFocused(): any {
        return this.Movie;
        // return this.List;
    }

    // override _active() {
    //     if (window.seasonSelectedIndex) {
    //         this._selectedSeason = window.seasonSelectedIndex;
    //         this.List.resetItems(this._data.seasons![this._selectedSeason]!.episodes || []);
    //         this.Seasons.items.map((item: any, index: number) => {
    //             item.isActive = this._selectedSeason === index;
    //             return item;
    //         });
    //
    //         this.Seasons.index = window.seasonSelectedIndex;
    //
    //         this.onIndexChanged({
    //             index: window.seasonSelectedIndex
    //         });
    //
    //         window.seasonSelectedIndex = undefined;
    //     }
    //
    //     if (window.selectedIndex) {
    //         this.List.index = window.selectedIndex;
    //         window.selectedIndex = undefined;
    //     }
    // }
    //
    // override _handleUp() {
    //     if (this._hasSeasons) {
    //         this._setState("SeasonState");
    //     } else {
    //         window.selectedMovie = this._data;
    //         this.application.emit("updateSelectedMovie", window.selectedMovie);
    //
    //         this._setState("");
    //     }
    // }
    //
    // override _handleDown() {
    //     if (this._hasSeasons) {
    //         this._setState("SeasonState");
    //     } else {
    //         this._setState("");
    //     }
    // }
    //
    // static override _states() {
    //     return [
    //         class TopState extends this {
    //             override _getFocused() {
    //                 return this.Movie;
    //             }
    //
    //             override _handleUp() {}
    //
    //             override _handleDown() {
    //                 this._setState("SeasonState");
    //             }
    //         },
    //         class SeasonState extends this {
    //             override _getFocused() {
    //                 return this.Seasons;
    //             }
    //
    //             override _handleUp() {
    //                 this.onIndexChanged({
    //                     index: this._selectedSeason
    //                 });
    //
    //                 this._setState("TopState");
    //             }
    //
    //             override _handleDown() {
    //                 this.onIndexChanged({
    //                     index: this._selectedSeason
    //                 });
    //
    //                 this._setState("");
    //             }
    //         }
    //     ];
    // }
}
